import { SidebarTrigger } from './ui/sidebar';

interface PageTitleProps {
  /** The page title text */
  title: string;
  /** Hide the mobile sidebar trigger (use when the page already has one in breadcrumbs) */
  hideSidebarTrigger?: boolean;
  /** Additional className for the wrapper div (spacing, etc.) */
  className?: string;
  /** Override the h1 text style (default: text-2xl font-bold text-foreground) */
  titleClassName?: string;
}

export default function PageTitle({ title, hideSidebarTrigger = false, className, titleClassName }: PageTitleProps) {
  return (
    <div className={`flex items-center gap-2 ${className || ''}`}>
      {!hideSidebarTrigger && <SidebarTrigger className="md:hidden h-5 w-5 flex-shrink-0" />}
      <h1 className={titleClassName || 'text-2xl font-bold text-foreground'}>{title}</h1>
    </div>
  );
}
